export default {
    state: {
        profile: {
            filters: {},
        },
    },
    getters: {
        getProfileFilter: state => filter => {
            if (state.profile.filters[filter] == undefined) {
                state.profile.filters[filter] = true
            }
            return state.profile.filters[filter]
        },
    },
    mutations: {
        updateProfileFilter(state, { filter, value }) {
            state.profile.filters[filter] = value
        }
    },
    actions: {
        setProfileFilter({ commit }, filter) {
            commit('updateProfileFilter', filter)
        },
    }
}